import { DropdownNavProps, useDayPicker } from 'react-day-picker';
import { DropdownMenu } from '../DropdownMenu';
import { cn } from '@nexelem/utils';
import { CUSTOM_ICONS } from '@nexelem/icons';

export const DropdownNav = ({ children }: DropdownNavProps) => {
  const { dayPickerProps } = useDayPicker();
  const [dropdownContent, labelContainer] = Array.isArray(children) ? children : [children];

  const extractedLabel = labelContainer.props.children;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <span
          className={cn(
            'group flex cursor-pointer items-center gap-2 text-t16-sb text-nowrap text-text-action capitalize hover:text-text-hover data-[state=open]:text-text-focus',
          )}
        >
          {extractedLabel}
          <CUSTOM_ICONS.CaretDown className="group-data-[state=open]:rotate-180" />
        </span>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="start" className="z-5202 mt-2 flex flex-row gap-2 px-4 py-3">
        {dropdownContent}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
